<template>
  <div class="tracking">
    <div
      v-for="(stage, index) in stages"
      :key="stage.type"
      class="stage"
      :class="{ done: stage.done, current: stage.current, canceled: canceled }"
    >
      <span class="stage-num">
        <feather-icon
          v-if="stage.done && !stage.current"
          icon="CheckIcon"
          size="14"
        />
        <template v-else>{{ index + 1 }}</template>
      </span>
      <div class="stage-info">
        <div class="stage-label">
          {{ $t(`configurator.order_status.${stage.type}`) }}
        </div>
        <div class="stage-date">
          {{ stage.date || '' }}
        </div>
      </div>
    </div>
    <span
      v-if="canceled"
      class="cfg-badge cfg-badge-gray dot ml-auto"
    >{{ $t('configurator.order_status.canceled') }}</span>
  </div>
</template>

<script>
import { TimestampToFlatPickr } from '@/libs/helpers'

// Como el tarificador anterior: se ve solo la fase en curso (oferta o envío), máximo 4 estados
const OFFER_PHASE = ['pending', 'revision', 'budget', 'budget_admin']
const SHIPMENT_PHASE = ['ready', 'send', 'cast', 'delivered']
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  computed: {
    history() {
      return this.order.status || []
    },
    current() {
      return this.order.status_last ? this.order.status_last.type : 'pending'
    },
    canceled() {
      return this.current === 'canceled'
    },
    stages() {
      // La revisión solo aparece si la oferta ha pasado por ella
      const hadRevision = this.history.some(s => s.type === 'revision')
      const flow = SHIPMENT_PHASE.includes(this.current)
        ? SHIPMENT_PHASE
        : OFFER_PHASE.filter(type => type !== 'revision' || hadRevision)
      const reached = flow.indexOf(this.current)
      return flow.map((type, index) => {
        const entries = this.history.filter(s => s.type === type)
        const last = entries[entries.length - 1]
        return {
          type,
          date: last ? TimestampToFlatPickr(last.created) : null,
          done: !this.canceled && index <= reached,
          current: !this.canceled && index === reached,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tracking {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .25rem 0;
  padding: 1rem 1.5rem;
}
.stage {
  position: relative;
  display: flex;
  align-items: center;
  gap: .6rem;
  padding-right: 2rem;
  &::after {
    content: '›';
    position: absolute;
    right: .7rem;
    font-size: 1.25rem;
    color: #b8c2cc;
  }
  &:last-of-type::after {
    display: none;
  }
}
.stage-num {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 2px solid #b8c2cc;
  border-radius: 50%;
  font-size: .85rem;
  font-weight: 700;
  color: #82868b;
}
.stage-label {
  font-size: .85rem;
  font-weight: 500;
  color: #82868b;
  white-space: nowrap;
}
.stage-date {
  min-height: 1em;
  font-size: .7rem;
  color: #82868b;
}
.stage.done {
  .stage-num {
    border-color: #3a7d44;
    background: #3a7d44;
    color: #fff;
  }
  .stage-label {
    color: #6e6b7b;
  }
}
.stage.current {
  .stage-num {
    border-color: #ac1a19;
    background: #ac1a19;
    color: #fff;
  }
  .stage-label {
    font-weight: 600;
    color: #4d4d4d;
  }
}
.stage.canceled {
  opacity: .5;
}
</style>
